<div class="kz-pro-listing-ad-faq--content">
  <h2 class="kz-pro-listing-ad-faq--title kz-title" i18n="@@pro.listing.ad.faq.title">How to choose your interior decorator?</h2>
  <p>
    <ng-container i18n="@@pro.listing.ad.faq.content.l1">Today, the offers of interior decorators and decorators are numerous.</ng-container><br>
    <ng-container i18n="@@pro.listing.ad.faq.content.l2">So how do you choose the one with which you want to embark on your decoration project?</ng-container>
  </p>

</div>
<div class="kz-pro-listing-ad-faq--visu">
  <app-picture-source
    imgSrc="/assets/images/annuaire/ad/pro-listing-ad-faq-bg.png"
    [presets]="'w460' | imgPreset"
    [alt]="''"
    [imgFit]="true"
    useWebp="true" useLazyLoad="true"
    handleX2="true" [handleX3]="false"
    preloadImages="true"
  ></app-picture-source>
  <button kzButton buttonContext="decorator" buttonTxtStyle="none" [routerLink]="['.']" fragment="faq"><span i18n="@@pro.listing.ad.faq.cta">Discover the FAQ</span></button>
</div>
